export default {
    components: {
        ui: {},
        network: {
            addmember: "components.network.addmember",
        },
        common: {
            schoolSelector: "components.common.schoolselector",
            paymentModal: "components.common.paymentmodal",
        },
        shop: {
            inpersonqrarea: "components.shop.inpersonqrarea",
        },
        // Add message center component namespaces
        admin: {
            messagecenter: {
                messageHistoryDetailView: "components.admin.messagecenter.messagehistorydetailview",
                recipientListModal: "components.admin.messagecenter.recipientlistmodal",
            },
            payment: {
                makepaymentdialog: "components.admin.payment.makepaymentdialog",
                removepaymentdialog: "components.admin.payment.removepaymentdialog",
                refundpaymentdialog: "components.admin.payment.refundpaymentdialog",
            },
        },
    },
    layouts: {
        account: "layouts.account",
        base: "layouts.base",
        admin: "layouts.admin",
        main: "layouts.main",
        userProfile: "layouts.userProfile",
        portal: "layouts.portal",
        corporate: "layouts.corporate",
        plain: "layouts.plain",
        practice: "layouts.practice",
        dashboard: "layouts.dashboard",
        errors: "layouts.errors",
        navbars: {
            admin: "layouts.navbars.admin",
            auth: "layouts.navbars.auth",
            portal: "layouts.navbars.portal",
            mobile: "layouts.navbars.mobile",
            search: "layouts.navbars.search",
        },
        sidebar: {
            sidebar: "layouts.sidebar.sidebar",
        },
        footers: {
            portalfooter: "layouts.footers.portalfooter",
        },
    },
    screens: {
        account: {
            login: "screens.account.login",
            oldlogin: "screens.account.oldlogin",
            userlogin: "screens.account.userlogin",
            userregister: "screens.account.userregister",
            forgotpassword: "screens.account.forgotpassword",
            changepassword: "screens.account.changepassword",
            register: "screens.account.register",
            ssoredirect: "screens.account.ssoredirect",
        },
        admin: {
            dashboard: "screens.admin.dashboard",
            user: {
                manageemployeeuser: "screens.admin.user.manageemployeeuser",
                manageconsumeruser: "screens.admin.user.manageconsumeruser",
                manageuser: "screens.admin.user.manageuser",
                manageprovideruser: "screens.admin.user.manageprovideruser",
                manageregionuser: "screens.admin.user.manageregionuser",
                managestoreuser: "screens.admin.user.managestoreuser",
            },
            facility: {
                facilityaccess: "screens.admin.facility.facilityaccess",
                facilitycheckin: "screens.admin.facility.facilitycheckin",
                facilityliveview: "screens.admin.facility.facilityliveview",
                facilityaccesshistory: "screens.admin.facility.facilityaccesshistory",
                editfacilityaccess: "screens.admin.facility.editfacilityaccess",
            },
            network: {
                membermanagement: "screens.admin.network.membermanagement",
                activatemembers: "screens.admin.network.activatemembers",
                memberactivityhistory: "screens.admin.network.memberactivityhistory",
                suspensiondetail: "screens.admin.network.suspensiondetail",
                editsuspension: "screens.admin.network.editsuspension",
                suspensions: "screens.admin.network.suspensions",
                ineligibility: "screens.admin.network.ineligibility",
                teammanagement: "screens.admin.network.teammanagement",
                sidmanagement: "screens.admin.network.sidmanagement",
                sidimport: "screens.admin.network.sidimport",
                createaccounts: "screens.admin.network.createaccounts",
                accountimport: "screens.admin.network.accountimport",
                addofficial: "screens.admin.network.addofficial",
            },
            featureconfiguration: "screens.admin.featureconfiguration",
            setting: "screens.admin.setting",
            products: {
                create: "screens.admin.products.create",
                details: "screens.admin.products.details",
                list: "screens.admin.products.list",
            },
            order: {
                create: "screens.admin.order.create",
                list: "screens.admin.order.list",
                details: "screens.admin.order.details",
            },
            invoices: {
                create: "screens.admin.invoices.create",
                list: "screens.admin.invoices.list",
                details: "screens.admin.invoices.details",
                invoice: "screens.admin.invoices.invoice",
            },
            ecommerce: "screens.admin.ecommerce",
            checkout: "screens.admin.checkout",
            equipment: {
                home: "screens.admin.equipment.home",
                items: "screens.admin.equipment.items",
                categories: "screens.admin.equipment.categories",
                checkouts: "screens.admin.equipment.checkouts",
                reports: "screens.admin.equipment.reports",
                reservations: "screens.admin.equipment.reservations",
                managers: "screens.admin.equipment.managers",
                editmanager: "screens.admin.equipment.editmanager",
                equipmentpolicy: "screens.admin.equipment.equipmentpolicy",
                viewitem: "screens.admin.equipment.viewitem",
                edititem: "screens.admin.equipment.edititem",
                editcheckout: "screens.admin.equipment.editcheckout",
                editreservation: "screens.admin.equipment.editreservation",
                viewitemv2: "screens.admin.equipment.viewitemv2",
                itemsv2: "screens.admin.equipment.itemsv2",
                edititemv2: "screens.admin.equipment.edititemv2",
                editcheckoutv2: "screens.admin.equipment.editcheckoutv2",
                editreservationv2: "screens.admin.equipment.editreservationv2",
                viewcheckoutdetailv2: "screens.admin.equipment.viewcheckoutdetailv2",
                viewreservationdetailv2: "screens.admin.equipment.viewreservationdetailv2",
            },
            makepayment: "screens.admin.makepayment",
            membership: {
                membershiplist: "screens.admin.membership.membershiplist",
                editmembership: "screens.admin.membership.editmembership",
                membershipdetail: "screens.admin.membership.membershipdetail",
                membershipusagehistory: "screens.admin.membership.membershipusagehistory",
            },
            mymemberships: "screens.admin.mymemberships",
            shop: {
                products: {
                    list: "screens.admin.shop.products.list",
                    edit: "screens.admin.shop.products.edit",
                    detail: "screens.admin.shop.products.detail",
                },
                cart: {
                    cart: "screens.admin.shop.cart.cart",
                },
                orders: {
                    list: "screens.admin.shop.orders.list",
                    detail: "screens.admin.shop.orders.detail",
                },
                checkout: {
                    checkout: "screens.admin.shop.checkout.checkout",
                },
            },
            payment: {
                received: "screens.admin.payment.received",
                required: "screens.admin.payment.required",
                details: "screens.admin.payment.details",
                gateway: "screens.admin.payment.gateway",
                inpersongateway: "screens.admin.payment.inpersongateway",
                restoremembercredits: "screens.admin.payment.restoremembercredits",
                couponcodes: "screens.admin.payment.couponcodes",
                couponused: "screens.admin.payment.couponused",
            },
            offerings: "screens.admin.offerings",
            offeringssettings: "screens.admin.offeringssettings",
            eventcalendar: {
                calendarlist: "screens.admin.eventcalendar.calendarlist",
                editcalendar: "screens.admin.eventcalendar.editcalendar",
            },
            locker: {
                roomlist: "screens.admin.locker.roomlist",
                editroom: "screens.admin.locker.editroom",
                floorplandesign: "screens.admin.locker.floorplandesign",
                lockermanage: "screens.admin.locker.lockermanage",
            },
            messagehistory: "screens.admin.messagehistory",
            messagecenter: "screens.admin.messagecenter",
            messagehistorydetail: "screens.admin.messagehistorydetail",
        },
        portal: {
            home: "screens.portal.home",
            offerings: "screens.portal.offerings",
            detail: "screens.portal.detail",
            register: "screens.portal.register",
            payment: "screens.portal.payment",
            facilitycalendar: "screens.portal.facilitycalendar",
            viewmessagecenter: "screens.portal.viewmessagecenter",
        },
        plain: {},
        dashboard: {
            account: "screens.dashboard.account",
            customers: "screens.dashboard.customers",
            integrations: "screens.dashboard.integrations",
            settings: "screens.dashboard.settings",
        },
        errors: {
            notfound: "screens.errors.notfound",
        },
        about: "screens.about",
        default: "screens.default",
        schoolSelection: "screens.schoolSelection",
    },
    session: "session",
    taskqueue: "taskqueue",
};
